// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EnrollmentV2ProcessingResultModel } from './enrollmentV2ProcessingResultModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class EnrollmentEnrollmentEnrollPatientDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': EnrollmentV2ProcessingResultModel | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EnrollmentEnrollmentEnrollPatientDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "EnrollmentV2ProcessingResultModel"
        },
    ];

    static getAttributeTypeMap() {
        return EnrollmentEnrollmentEnrollPatientDefaultResponse.attributeTypeMap;
    }
}
